import defaultFavicon from '@/assets/favicons/faviconDefault.ico';
import domainDVFavicon from '@/assets/favicons/faviconDv.ico';

export function getCurrentDomain() {
    return window.location.hostname;
}

export function setTitleAndFavicon(domain: string) {
    let title = 'CDP';
    let favicon = defaultFavicon;

    if (domain.includes('dvgroup.com')) {
        title = 'DV Group CDP';
        favicon = domainDVFavicon;
    }

    if (domain.includes('cvdashboard.ru')) {
        title = 'CooperVision CDP';
        favicon = defaultFavicon;
    }

    document.title = title;
    const link: any = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = favicon;
    document.getElementsByTagName('head')[0].appendChild(link);
}